(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/views/nodata.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/views/nodata.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.statistics=_svs.statistics||{};
_svs.statistics.statistics=_svs.statistics.statistics||{};
_svs.statistics.statistics.templates=_svs.statistics.statistics.templates||{};
svs.statistics.statistics.templates.nodata = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "      <div class=\"statistic-notice-message\"></div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "      <i class=\"statistic-notice-icon icon-default icon-exclamation-sign\"></i>\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.message : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var helper;

  return "        <div class=\"statistic-notice-message\">"
    + container.escapeExpression(((helper = (helper = helpers.message || (depth0 != null ? depth0.message : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"message","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "        <div class=\"statistic-notice-message\">Ingen statistik är tillgänglig</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<ul class=\"statistics-elements fc-grey-500\">\n  <li class=\"statistic-element\">\n    <div class=\"statistic-notice statistic-notice-again\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.renderEmpty : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "    </div>\n  </li>\n</ul>\n";
},"useData":true});
Handlebars.partials['components-statistics-statistics-nodata'] = svs.statistics.statistics.templates.nodata;
})(svs, Handlebars);

 })(window);